import React from 'react';
import SvgIcon from 'material-ui-next/SvgIcon';

export default props => (
  <SvgIcon {...props}>
    <path d="M12,10L8,14H11V20H13V14H16M19,4H5C3.89,4 3,4.9 3,6V18A2,2 0 0,0 5,20H9V18H5V8H19V18H15V20H19A2,2 0 0,0 21,18V6A2,2 0 0,0 19,4Z" />
  </SvgIcon>
);



// WEBPACK FOOTER //
// ./src/assets/icons/updateIcon.react.js